import { Box, Grid } from '@mui/material';
import { useState } from 'react';
import { ICandidateSubmissionSearchFilterVM, IJob, IJobCandidateInteraction } from 'wisestep-api';
import { ScrollableTabs, TabTextVariant, WsListingLoader } from 'wisestep-base';

import useListingCandidates from '../../../../features/submissions/hooks/useListingCandidates';
import useSubmissionsNewContext from '../../../../features/submissionsNew/components/hooks/useSubmissionsNewContext';
import { tabList } from '../../utils/similarJobsHelper';

import SimilarJobMappings from './SimilarJobMappings';
import SimilarJobSubmissions from './SimilarJobSubmissions';

interface SimilarCandidateListingProps {
  mappingQuery: IJobCandidateInteraction;
  submissionQuery: ICandidateSubmissionSearchFilterVM;
  updateSubmissionQuery: (updatedSubmissionQuery: ICandidateSubmissionSearchFilterVM) => void;
  updateMappingsQuery: (updatedMappingQuery: IJobCandidateInteraction) => void;
  handleTabChange: (value: number) => void;
  tabIndex: number;
  job: IJob;
}

const SimilarCandidateListing = ({
  mappingQuery,
  submissionQuery,
  updateSubmissionQuery,
  updateMappingsQuery,
  handleTabChange,
  tabIndex,
  job,
}: SimilarCandidateListingProps) => {
  const [loadMappings, setLoadMappings] = useState<boolean>(false);
  const mappings = useListingCandidates(mappingQuery, setLoadMappings, 'jobCRM');
  const { submissions, loader } = useSubmissionsNewContext(submissionQuery, true);

  const onMappingPageChange = (val: number) => {
    const updatedQuery = { ...mappingQuery };
    updatedQuery.page = val;
    updateMappingsQuery(updatedQuery);
  };

  const onSubmissionPageChange = (val: number) => {
    const updatedQuery = { ...submissionQuery };
    updatedQuery.page = val;
    updateSubmissionQuery(updatedQuery);
  };
  return (
    <Box display="flex" flexDirection="column" rowGap={2} width="100%">
      <Grid item xs={12}>
        <ScrollableTabs
          defaultValue={tabIndex}
          scrollList={tabList(mappings?.totalElements, submissions?.totalElements)}
          getTabIndex={handleTabChange}
          variant={TabTextVariant.SUB_TITLE}
        />
      </Grid>
      <Grid item xs={12}>
        {tabIndex === 0 &&
          (loader ? (
            <WsListingLoader />
          ) : (
            <SimilarJobSubmissions
              data={submissions}
              job={job}
              pagination={{ pageNumber: submissionQuery.page, size: submissionQuery.size }}
              onPageChange={onSubmissionPageChange}
            />
          ))}
        {tabIndex === 1 &&
          (loadMappings ? (
            <WsListingLoader />
          ) : (
            <SimilarJobMappings
              job={job}
              data={mappings}
              pagination={{ pageNumber: mappingQuery.page, size: mappingQuery.size ?? 20 }}
              onPageChange={onMappingPageChange}
            />
          ))}
      </Grid>
    </Box>
  );
};

export default SimilarCandidateListing;
